import m from "../../geodata/es2015/austriaLow";
window.am4geodata_austriaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/austriaLow.js
// module id = null
// module chunks = 